import { useEffect, useState } from "react";
import { apiFetch } from "../services/auth";

export type BackendStatus = "ok" | "degraded" | "down" | "checking";

export interface UseBackendStatusResult {
  status: BackendStatus;
  latencyMs: number | null;
  lastCheckedAt: Date | null;
}

/**
 * Polling do /api/health a cada `intervalMs` (default 30s).
 * Usa /api/health (ping rápido sem DB) para indicador de topo.
 */
export function useBackendStatus(intervalMs = 30_000): UseBackendStatusResult {
  const [status, setStatus] = useState<BackendStatus>("checking");
  const [latencyMs, setLatencyMs] = useState<number | null>(null);
  const [lastCheckedAt, setLastCheckedAt] = useState<Date | null>(null);

  useEffect(() => {
    let alive = true;
    const check = async () => {
      const t0 = performance.now();
      try {
        await apiFetch<{ success: true; data: { status: string } }>("/api/health");
        if (!alive) return;
        const elapsed = Math.round(performance.now() - t0);
        setStatus("ok");
        setLatencyMs(elapsed);
        setLastCheckedAt(new Date());
      } catch {
        if (!alive) return;
        setStatus("down");
        setLatencyMs(null);
        setLastCheckedAt(new Date());
      }
    };
    void check();
    const id = setInterval(() => void check(), intervalMs);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, [intervalMs]);

  return { status, latencyMs, lastCheckedAt };
}
